import "core-js/modules/es.error.cause.js";
export default {
  data() {
    return {
      form: {
        password: '',
        //新密码
        password_confirmation: '' //确认密码
      }
    };
  },
  computed: {
    rules() {
      return {
        password: [{
          required: true,
          message: this.$t('请输入') + this.$t('新密码'),
          trigger: 'blur'
        }, {
          min: 8,
          max: 16,
          message: this.$t('请输入8-16位数字、大小写字母组合'),
          trigger: 'blur'
        }, {
          pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{8,16}$/,
          message: this.$t('请输入8-16位数字、大小写字母组合'),
          trigger: 'blur'
        }],
        password_confirmation: [{
          required: true,
          message: this.$t('请再次输入') + this.$t('新密码'),
          trigger: 'blur'
        }, {
          validator: (rule, value, callback) => {
            if (value !== this.form.password) {
              callback(new Error(this.$t('两次密码输入不一致')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      };
    }
  },
  mounted() {},
  methods: {
    handleInputPwd(key) {
      this.form[key] = this.form[key].replace(/\s/g, '');
    },
    handleBlurTrim(key) {
      this.form[key] = this.form[key].trim();
    }
  }
};